import BaseApiAction from '@Actions/base-api-action';

export default class SecureRequestSigninLink extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'secure-secureRequestSigninLink',
      payload: {
        user_email: this._payload.user_email,
      },
    });
  }
}
